const fonts = {
  bodyFont: `'SourceSansProRegular', 'Overpass', Helvetica, Arial, sans-serif`,
  titleFont: `'SourceSansProRegular', 'Overpass', Helvetica, Arial, sans-serif`,
  boldFont: `'SourceSansProBold', 'OverpassBold', Helvetica, Arial, sans-serif`,
  semiBoldFont: `'SourceSansProSemibold', 'OverpassSemibold', Helvetica, Arial, sans-serif`,
  lightFont: `'SourceSansProLight', 'OverpassBold', Helvetica, Arial, sans-serif`,
  buttonFont: `'SourceSansProSemibold','Overpass', 'Helvetica Neue',Arial`,
}

fonts.fontFaces = `
  @font-face {
    font-family: 'SourceSansProRegular';
    src: url('/public/assets/fonts/SourceSansProRegular.eot');
    src: url('/public/assets/fonts/SourceSansProRegular.eot') format('embedded-opentype'),
        url('/public/assets/fonts/SourceSansProRegular.woff2') format('woff2'),
        url('/public/assets/fonts/SourceSansProRegular.woff') format('woff'),
        url('/public/assets/fonts/SourceSansProRegular.ttf') format('truetype'),
        url('/public/assets/fonts/SourceSansProRegular.svg#SourceSansProRegular') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'SourceSansProBold';
    src: url('/public/assets/fonts/SourceSansProBold.eot');
    src: url('/public/assets/fonts/SourceSansProBold.eot') format('embedded-opentype'),
        url('/public/assets/fonts/SourceSansProBold.woff2') format('woff2'),
        url('/public/assets/fonts/SourceSansProBold.woff') format('woff'),
        url('/public/assets/fonts/SourceSansProBold.ttf') format('truetype'),
        url('/public/assets/fonts/SourceSansProBold.svg#SourceSansProBold') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'SourceSansProSemibold';
    src: url('/public/assets/fonts/SourceSansProSemibold.eot');
    src: url('/public/assets/fonts/SourceSansProSemibold.eot') format('embedded-opentype'),
        url('/public/assets/fonts/SourceSansProSemibold.woff2') format('woff2'),
        url('/public/assets/fonts/SourceSansProSemibold.woff') format('woff'),
        url('/public/assets/fonts/SourceSansProSemibold.ttf') format('truetype'),
        url('/public/assets/fonts/SourceSansProSemibold.svg#SourceSansProSemibold') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'SourceSansProLight';
    src: url('/public/assets/fonts/SourceSansProLight.eot');
    src: url('/public/assets/fonts/SourceSansProLight.eot') format('embedded-opentype'),
        url('/public/assets/fonts/SourceSansProLight.woff2') format('woff2'),
        url('/public/assets/fonts/SourceSansProLight.woff') format('woff'),
        url('/public/assets/fonts/SourceSansProLight.ttf') format('truetype'),
        url('/public/assets/fonts/SourceSansProLight.svg#SourceSansProLight') format('svg');
    font-weight: normal;
    font-style: normal;
  }
`

export default fonts
